export default __webpack_public_path__ + "static/media/icon-reader-circle.a6446e70.svg";